// extracted by mini-css-extract-plugin
module.exports = {"card":"MechanicTypeCard_card__1HHhx"};